(function(){
  var root = document.querySelector('.gpdp'); if(!root) return;
  /* galerie + lightbox */
  var th = root.querySelector('#gp-th'), mimg = root.querySelector('#gp-mimg');
  var lb = root.querySelector('#gp-lb'), lbImg = root.querySelector('#gp-lb-img');
  var thumbs = th ? [].slice.call(th.querySelectorAll('img')) : [];
  var imgs = thumbs.map(function(t){ return t.dataset.full || t.src; });
  var cur = 0;
  function selectMain(i){ if(i<0||i>=imgs.length) return; cur = i; if(mimg) mimg.src = imgs[i]; thumbs.forEach(function(t,k){ t.classList.toggle('on', k===i); }); }
  function openLB(i){ if(!lb||!imgs.length) return; selectMain(i); lbImg.src = imgs[cur]; lb.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeLB(){ if(!lb) return; lb.hidden = true; document.body.style.overflow = ''; }
  function navLB(d){ if(!imgs.length) return; selectMain((cur + d + imgs.length) % imgs.length); lbImg.src = imgs[cur]; }
  if(th){ th.addEventListener('click', function(e){ var t = e.target.closest('img'); if(!t) return; var i = thumbs.indexOf(t); if(i > -1) openLB(i); }); }
  if(mimg){ mimg.addEventListener('click', function(){ openLB(cur); }); }
  if(lb){
    lb.addEventListener('click', function(e){ if(e.target === lb || e.target.hasAttribute('data-lb-close')) closeLB(); });
    var pv = lb.querySelector('[data-lb-prev]'), nx = lb.querySelector('[data-lb-next]');
    if(pv) pv.addEventListener('click', function(e){ e.stopPropagation(); navLB(-1); });
    if(nx) nx.addEventListener('click', function(e){ e.stopPropagation(); navLB(1); });
    document.addEventListener('keydown', function(e){ if(lb.hidden) return; if(e.key === 'Escape') closeLB(); else if(e.key === 'ArrowLeft') navLB(-1); else if(e.key === 'ArrowRight') navLB(1); });
  }
  /* variantes (vrai formulaire Shopify) */
  var form = root.querySelector('#gp-form'); if(!form) return;
  var VARIANTS = window.gpdpVariants;
  var idInput = form.querySelector('[data-gp-id]');
  var atc = form.querySelector('[data-gp-atc]');
  var nowEl = root.querySelector('[data-gp-now]'), oldEl = root.querySelector('[data-gp-old]'), offEl = root.querySelector('[data-gp-off]');
  var inEl = root.querySelector('[data-gp-instock]'), oosEl = root.querySelector('[data-gp-oos]');
  function money(cents){ try{ return (cents/100).toLocaleString('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2}).replace(/ /g,' ') + ' €'; }catch(e){ return (cents/100).toFixed(2) + ' €'; } }
  function current(){
    var groups = form.querySelectorAll('.gp-opts'); var sel = {};
    groups.forEach(function(g){ var i = +g.dataset.optIndex; var on = g.querySelector('.gp-opt.on'); if(on) sel[i] = on.dataset.value; });
    return VARIANTS.find(function(v){ for(var k in sel){ if(v.options[k-1] !== sel[k]) return false; } return true; });
  }
  /* Disponibilite option par option. Une valeur est grisee et barree s'il
     n'existe aucune variante commandable qui la porte, les autres options
     restant sur leur choix courant. Sans ce marquage, un grip 1 epuise
     s'affichait exactement comme un grip 2 en stock : le client ne
     decouvrait la rupture qu'apres avoir clique, en lisant « Epuise »
     ailleurs sur la page. Le bouton reste cliquable a dessein — on veut
     qu'il puisse consulter le prix et la reference d'une taille absente. */
  function majDispo(){
    if(!VARIANTS) return;
    var groups = [].slice.call(form.querySelectorAll('.gp-opts'));
    if(!groups.length) return;
    var sel = {};
    groups.forEach(function(g){
      var on = g.querySelector('.gp-opt.on');
      if(on) sel[+g.dataset.optIndex] = on.dataset.value;
    });
    groups.forEach(function(g){
      var gi = +g.dataset.optIndex;
      [].forEach.call(g.querySelectorAll('.gp-opt'), function(b){
        var ok = VARIANTS.some(function(v){
          if(v.options[gi-1] !== b.dataset.value) return false;
          for(var k in sel){ if(+k !== gi && v.options[k-1] !== sel[k]) return false; }
          return !!v.available;
        });
        b.classList.toggle('gp-opt-out', !ok);
        if(ok) b.removeAttribute('title');
        else b.setAttribute('title', 'Indisponible pour le moment');
      });
    });
  }

  /* quantite : pas a pas, borne par le stock reel de la variante */
  var qtyWrap = form.querySelector('[data-gp-qty]');
  var qtyIn = form.querySelector('[data-gp-qty-input]');
  var qtyMinus = form.querySelector('[data-gp-qty-minus]');
  var qtyPlus = form.querySelector('[data-gp-qty-plus]');
  var qtyMax = 99;
  function maxDe(vv){
    /* Stock suivi et survente refusee : on ne laisse pas commander plus qu'il
       n'existe, sinon l'ajout au panier echoue sans rien expliquer au client. */
    if(!vv) return 99;
    if(vv.inventory_management && vv.inventory_policy === 'deny'){
      return Math.max(1, Math.min(99, vv.inventory_quantity || 1));
    }
    return 99;
  }
  function setQty(n){
    if(!qtyIn) return;
    n = Math.round(n);
    if(!isFinite(n) || n < 1) n = 1;
    if(n > qtyMax) n = qtyMax;
    qtyIn.value = n;
    if(qtyMinus) qtyMinus.disabled = (n <= 1);
    if(qtyPlus) qtyPlus.disabled = (n >= qtyMax);
  }
  if(qtyMinus) qtyMinus.addEventListener('click', function(){ setQty((+qtyIn.value || 1) - 1); });
  if(qtyPlus) qtyPlus.addEventListener('click', function(){ setQty((+qtyIn.value || 1) + 1); });
  if(qtyIn){
    qtyIn.addEventListener('change', function(){ setQty(+qtyIn.value); });
    qtyIn.addEventListener('blur', function(){ setQty(+qtyIn.value); });
  }

  function apply(){
    /* Le marquage des ruptures precede la sortie anticipee : meme quand la
       combinaison choisie n'existe pas, le client doit voir lesquelles sont
       commandables. */
    majDispo();
    var vv = current(); if(!vv) return;
    idInput.value = vv.id;
    qtyMax = maxDe(vv);
    if(qtyIn) qtyIn.max = qtyMax;
    setQty(+((qtyIn && qtyIn.value) || 1));
    if(qtyWrap) qtyWrap.hidden = !vv.available;
    if(nowEl) nowEl.textContent = money(vv.price);
    if(oldEl){ if(vv.compare_at_price && vv.compare_at_price > vv.price){ oldEl.textContent = money(vv.compare_at_price); oldEl.hidden = false; if(offEl){ offEl.textContent = '-' + Math.round((vv.compare_at_price - vv.price)*100/vv.compare_at_price) + ' %'; offEl.hidden = false; } } else { oldEl.hidden = true; if(offEl) offEl.hidden = true; } }
    if(atc){ atc.disabled = !vv.available; atc.textContent = vv.available ? 'Ajouter au panier' : 'Épuisé'; }
    if(inEl) inEl.hidden = !vv.available; if(oosEl) oosEl.hidden = vv.available;
  }
  form.querySelectorAll('.gp-opts').forEach(function(g){ g.addEventListener('click', function(e){ var b = e.target.closest('.gp-opt'); if(!b) return; [].forEach.call(g.querySelectorAll('.gp-opt'), function(x){ x.classList.remove('on'); }); b.classList.add('on'); apply(); }); });
  apply();
})();
